import store from '@/store/store'
// import Router from '@/router'
import Auth from '@/modules/auth/models/Auth'
import { TokenService } from '@/services/storage.service'
import Config from '@/modules/config/models/Config'

export default {
  methods: {
    async logout(type, inactive = false) {
      let link = await this.logoutReturnUrl(type, inactive)
      window.location.replace(link)
    },
    async logoutReturnUrl(type, inactive = false) {
      let redirectUrl = `/${type}/login`
      if (Config.value('isSDECC') == 1 && type == 'user') {
        type = 'student'
        redirectUrl = '/user/login'
      }

      if (type === 'individual') {
        redirectUrl = '/parent/login'
      }
      try {
        if (
          Auth.query()
            .where('type', type)
            .first()
        ) {
          await Auth.dispatch('logout', `${type}s`)
        } else {
          const cookies = [`jwt_${type}-exp`, `${type}-last-activity`]
          cookies.forEach(cookie => {
            TokenService.removeToken(cookie)
          })
        }
      } catch (error) {
        console.log('Invisible user logout')
      } finally {
        store.commit('snackbar/showSnackbar', 'Logging out.')
      }
      if (inactive) {
        redirectUrl += '?inactive=true'
      }
      return redirectUrl
    }
  }
}
